import { atom } from 'recoil';

export const TICKET_SELECT_KEYS = {
  assign: 'assign'
}

const ticketSelectState = atom({
  key: 'ticketSelectState',
  default: {
    [TICKET_SELECT_KEYS.assign]: []
  }
});

export default ticketSelectState;